var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "form-group mr-1 flex-grow-1" }, [
            _c("label", [_vm._v("Тип звонков")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.type,
                    expression: "filter.type",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.filter,
                        "type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    () => (_vm.filter.typeIds = []),
                  ],
                },
              },
              [
                _c("option", { attrs: { value: "1" } }, [
                  _vm._v("Вх. звонки с мини-формой отказа"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { disabled: "", value: "2" } }, [
                  _vm._v("Звонки по отказам у менеджера"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { disabled: "", value: "3" } }, [
                  _vm._v("Вх. звонки без заказов и без мини-формы"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { disabled: "", value: "4" } }, [
                  _vm._v("Звонки по выполненным заявкам"),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group mr-1 flex-grow-1" },
            [
              _c("label", [_vm._v("Статусы")]),
              _vm._v(" "),
              _c("multiselect", {
                staticClass: "custom_multiselect",
                attrs: {
                  options: _vm.statusesForSelect[_vm.filter.type],
                  placeholder: "Выберите статусы",
                  "track-by": "title",
                  label: "title",
                  showLabels: false,
                  searchable: true,
                  multiple: true,
                },
                model: {
                  value: _vm.filter.typeIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "typeIds", $$v)
                  },
                  expression: "filter.typeIds",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group flex-grow-1 drug_select" },
            [
              _c("label", [_vm._v("Препарат")]),
              _vm._v(" "),
              _c("DrugSearchNew", {
                attrs: {
                  minHeight: "41",
                  onSelect: (d) => (_vm.filter.selectedDrug = d),
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-content-between" }, [
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Продолжительность более")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.durationMore,
                    expression: "filter.durationMore",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "number" },
                domProps: { value: _vm.filter.durationMore },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "durationMore", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group ml-2" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.hideWORecords,
                      expression: "filter.hideWORecords",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.filter.hideWORecords)
                      ? _vm._i(_vm.filter.hideWORecords, null) > -1
                      : _vm.filter.hideWORecords,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.filter.hideWORecords,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.filter,
                              "hideWORecords",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.filter,
                              "hideWORecords",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.filter, "hideWORecords", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" не показывать звонки без записи"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "align-self-end" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  type: "button",
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                  onClick: () => _vm.getRecords(1),
                  className: "btn btn-outline-info",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.records !== null
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("p", [
                _vm._v("Всего записей "),
                _c("strong", [_vm._v(_vm._s(_vm.paginator?.total ?? 0))]),
              ]),
              _vm._v(" "),
              _vm.paginator
                ? _c(
                    "div",
                    [
                      _c("paginate", {
                        attrs: {
                          "page-count": _vm.paginator.last_page,
                          "page-range": 10,
                          "margin-pages": 2,
                          "click-handler": _vm.getRecords,
                          "prev-text": "&laquo",
                          "next-text": "&raquo",
                          "container-class": "pagination",
                          "prev-class": "page-item",
                          "prev-link-class": "page-link",
                          "page-class": "page-item",
                          "page-link-class": "page-link",
                          "next-class": "page-item",
                          "next-link-class": "page-link",
                          "active-class": "active green_btn",
                        },
                        model: {
                          value: _vm.paginator.current_page,
                          callback: function ($$v) {
                            _vm.$set(_vm.paginator, "current_page", $$v)
                          },
                          expression: "paginator.current_page",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loading
                ? [
                    _c(
                      "table",
                      { staticClass: "table mt-1 table-sm table-hover" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.records, function (r, i) {
                            return _c("tr", { key: r.id }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    i +
                                      1 +
                                      (_vm.paginator.current_page - 1) *
                                        _vm.paginator.per_page
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(_vm.sortedTypes[r.type_id].title)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(r.phone_call?.ip_phone?.description)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  r.drug?.id
                                    ? [
                                        _vm._v(
                                          "\n                (" +
                                            _vm._s(r.drug.id) +
                                            ") " +
                                            _vm._s(r.drug.title) +
                                            "\n              "
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(r.drug_title) +
                                            "\n              "
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _vm._l(r.data?.comments ?? [], function (c) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-top mt-1 comments_block",
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "font-italic" },
                                          [_vm._v(_vm._s(c.text))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-muted text-right",
                                          },
                                          [_vm._v(_vm._s(c.user_name))]
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  r.phone_call?.file_link
                                    ? [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(r.phone_call.call_duration)
                                            ),
                                          ]),
                                          _vm._v(" сек."),
                                        ]),
                                        _vm._v(" "),
                                        _c("PlayAudioByRequest", {
                                          attrs: { record: r.phone_call },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.updateRecord(
                                          $event,
                                          "newComment",
                                          r
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        disabled: _vm.savingRecord,
                                        required: +r.status > 1,
                                        type: "text",
                                        placeholder:
                                          "Комментарий к записи для коллег",
                                        name: "comment",
                                      },
                                    }),
                                    _vm._v(" "),
                                    +r.status > 1
                                      ? _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled: _vm.savingRecord,
                                            required: +r.status > 1,
                                            type: "text",
                                            name: "recordReview",
                                            placeholder: "независимая оценка",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: r.status,
                                              expression: "r.status",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: { disabled: _vm.savingRecord },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                r,
                                                "status",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "0",
                                                disabled: "",
                                              },
                                            },
                                            [_vm._v("Выберите статус")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "1" } },
                                            [_vm._v("Не требует внимания")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "2" } },
                                            [_vm._v("Требует внимания")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "3" } },
                                            [
                                              _vm._v(
                                                "Высокий приоритет внимания"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "4" } },
                                            [_vm._v("Звонок для примера")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(1, true),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "created_td" }, [
                                _c(
                                  "p",
                                  [
                                    _vm._v(
                                      "\n                (" +
                                        _vm._s(r.user_id) +
                                        ")\n                "
                                    ),
                                    _c("UserName", {
                                      attrs: { id: r.user_id },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.printDate(r.created_at))),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.paginator
                      ? _c(
                          "div",
                          [
                            _c("paginate", {
                              attrs: {
                                "page-count": _vm.paginator.last_page,
                                "page-range": 10,
                                "margin-pages": 2,
                                "click-handler": _vm.getRecords,
                                "prev-text": "&laquo",
                                "next-text": "&raquo",
                                "container-class": "pagination",
                                "prev-class": "page-item",
                                "prev-link-class": "page-link",
                                "page-class": "page-item",
                                "page-link-class": "page-link",
                                "next-class": "page-item",
                                "next-link-class": "page-link",
                                "active-class": "active green_btn",
                              },
                              model: {
                                value: _vm.paginator.current_page,
                                callback: function ($$v) {
                                  _vm.$set(_vm.paginator, "current_page", $$v)
                                },
                                expression: "paginator.current_page",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Тип звонка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Телефон")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запись")]),
        _vm._v(" "),
        _c("th", { staticClass: "comment_block" }),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-success", attrs: { type: "submit" } },
        [_vm._v("Сохранить")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }